module.exports = __webpack_public_path__ + "img/curve_line_icon.199296e7.svg";